import Dropdown from 'app/components/Dropdown';
import NewInput from 'app/components/NewInput';
import NumberInput from 'app/components/UI/NumberInput';
import { useCallback } from 'react';
import TextArea from 'app/components/Textarea';
import { isOtherReason, REJECTION_NOTE_MAX_LENGTH } from './rejectionReason';
import './InvoiceForm.scss';

const InvoiceForm = ({
  billrejectReson,
  billrejectReasonDropdown,
  approveBillManagement,
  rejectBillManagement,
  modelvalues,
  handlemodelvalues,
  handleMallChange,
  mallList,
  storeList,
  error,
  setrejectStatus,
  rejectStatus,
  billActionInFlight,
}) => {
  const handleSubmit = () => {
    approveBillManagement();
  };
  const handleReject = () => {
    billrejectReasonDropdown();
    setrejectStatus(true);
  };
  const handleRejectCall = () => {
    rejectBillManagement();
  };
  const handleInputChange = useCallback(
    (e) => {
      handlemodelvalues(e);
    },
    [handlemodelvalues]
  );
  const handleMallSelection = useCallback(
    (e) => {
      handleMallChange(e);
    },
    [handleMallChange]
  );
  const isOtherSelected = isOtherReason(modelvalues?.rejectionReason);
  const rejectionNote = modelvalues?.rejectionNote || '';

  return (
    <>
      {!rejectStatus ? (
        <>
          <div className='wd-100'>
            <Dropdown
              id={'mallId'}
              label='Mall name*'
              name='mallId'
              options={mallList}
              placeholder='Select Mall '
              value={modelvalues?.mallId}
              handleChange={handleMallSelection}
              // isFieldHidden={hideFields}
              isDisabled={modelvalues?.billStatus !== 1}
              errorText={error?.mallId}
            />
          </div>
          <div className='wd-100'>
            <Dropdown
              id={'storeId'}
              label='Store name*'
              name='storeId'
              options={storeList}
              value={modelvalues?.storeId}
              placeholder='Select Store '
              handleChange={handleInputChange}
              isDisabled={modelvalues?.billStatus !== 1}
              errorText={error?.storeId}
            />
          </div>
          <div className='wd-100'>
            <NewInput
              label='Invoice Number*'
              id='invoice_number'
              placeholder='Invoice Number'
              name='invoice_number'
              value={modelvalues?.invoice_number}
              isDisabled={modelvalues?.billStatus !== 1}
              onChange={handleInputChange}
            />
          </div>
          <div className='wd-100'>
            <NewInput
              type='date'
              label='Invoice Date*'
              id='start'
              placeholder='Discount'
              name='invoice_date'
              value={modelvalues?.invoice_date}
              isDisabled={modelvalues?.billStatus !== 1} //  errorText={error?.invoice_date}
              onChange={handleInputChange}
            />
          </div>
          <div className='wd-100'>
            <NumberInput
              label='Shopping amount*'
              id='shopping_amount'
              placeholder='Shopping amount'
              name='shopping_amount'
              value={modelvalues?.shopping_amount}
              isDisabled={modelvalues?.billStatus !== 1}
              onChange={handleInputChange}
            />
          </div>
          {modelvalues?.billStatus === 3 && (
            <div className='wd-100'>
              <TextArea
                id={'rejectionReason'}
                label='Rejection Reason'
                name='rejectionReason'
                rows={3}
                value={
                  modelvalues?.bill?.billAdditionalDetails?.rejectionReason ||
                  ''
                }
                readOnly
              />
            </div>
          )}
        </>
      ) : (
        <div className='wd-100'>
          <Dropdown
            id={'rejectionReason'}
            label='Rejection Reason*'
            name='rejectionReason'
            options={billrejectReson}
            placeholder='Rejection Reason'
            value={modelvalues.rejectionReason}
            handleChange={handleInputChange}
            errorText={error?.rejectionReason}
          />
          {isOtherSelected && (
            <div className='rejection-note'>
              <TextArea
                id={'rejectionNote'}
                label='Rejection Reason*'
                name='rejectionNote'
                placeholder='Type the reason for rejecting this bill'
                rows={3}
                value={rejectionNote}
                onChange={handleInputChange}
                maxLength={REJECTION_NOTE_MAX_LENGTH}
              />
              <small className='d-block text-end'>
                {rejectionNote.length}/{REJECTION_NOTE_MAX_LENGTH}
              </small>
            </div>
          )}
        </div>
      )}
      <div className='bottom-button flex gap-10'>
        <button
          onClick={rejectStatus ? handleRejectCall : handleReject}
          disabled={
            billActionInFlight ||
            modelvalues?.billStatus !== 1 ||
            (rejectStatus &&
              (!modelvalues?.rejectionReason ||
                (isOtherSelected && !rejectionNote.trim())))
          }
          className='border-btn'
        >
          Reject
        </button>
        <button
          disabled={
            billActionInFlight || rejectStatus || modelvalues?.billStatus !== 1
          }
          onClick={handleSubmit}
          className='button'
        >
          Approve
        </button>
      </div>
    </>
  );
};

export default InvoiceForm;
